<template>
  <div class="panel-header panel-header-sm"></div>
</template>
<script>
export default {};
</script>
<style>
.panel-header-sm {
  height: 56px;
  padding: 0px;
}
</style>
